export const SortOrders = {
  INCOME_BEFORE_TAX: 101,
  TAX_RATE: 102,
  INCOME_AT_SELECTED_RATE: 103,
};

export const Sections = {
  PROVISION_FOR_INCOME_TAXES: 'M',
  EFFECTIVE_TAX_RATE: 'N',
};

export const VIEW_BY_DROPLIST_ITEMS = {
  AMOUNTS: 'amounts',
  PERCENTAGES: 'percentages',
};

export const groupingFields = {
  BZ: 'businessDescription',
  BU: 'businessUnit',
  CC: 'companyCode',
  CO: 'countryCode',
  LE: 'legalEntity',
};

export const VIEW_TYPES = [
  {
    value: VIEW_BY_DROPLIST_ITEMS.AMOUNTS,
    label: 'View by Amounts',
  },
  {
    value: VIEW_BY_DROPLIST_ITEMS.PERCENTAGES,
    label: 'View by Percentages',
  },
];

